import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, OnDestroy} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal, NgbModal, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, NgbTypeahead, NgbHighlight } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from '../../../core/services/event.service';
import { AutocompleteService } from '../../../core/services/autocomplete.service';
import { Observable, of, OperatorFunction, Subscription} from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UtilityService } from '../../../core/services/utility.service';
import { MediaUploadService } from '../../../core/services/mediaUpload.service';
import { ConfirmAlertComponent } from '../confirm-alert/confirm-alert.component';
import { ToastrService } from 'ngx-toastr';
import { ThirtySecondsVideoRecordModalComponent } from '../thirty-seconds-video-record-modal/thirty-seconds-video-record-modal.component';
import { CitySuggestionComponent } from '../city-suggestion/city-suggestion.component';
import { ScrollSelectComponent, ScrollSelectOption } from '../scroll-select/scroll-select.component';
import { InputRestrictionDirective } from '../../directives/input-restriction.directive';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { LogoUrlPipe, normalizeLogoUrl } from '../../pipes/logo-url.pipe';

@Component({
    selector: 'add-education-modal',
    templateUrl: './add-education-modal.component.html',
    styleUrls: ['./add-education-modal.component.scss'],
    imports: [NgClass, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, FormsModule, NgbTypeahead, InputRestrictionDirective, NgbHighlight, CitySuggestionComponent, ScrollSelectComponent, LogoUrlPipe]
})
export class AddEducationModalComponent implements OnInit, AfterViewInit, OnDestroy {
	private subs = new Subscription();


	@Input() data: any = {};
	@Input() id: any;
	@Input() delete: boolean = false;
	@Input() pageStatus: any;
	@Input() ctrl: any;
	@Output() deleteFn: EventEmitter<any> = new EventEmitter<any>();
	@Output() educationEditFn: EventEmitter<any> = new EventEmitter<any>();
	@Output() educationAddFn: EventEmitter<any> = new EventEmitter<any>();
	@Output() educationEditFnGs: EventEmitter<any> = new EventEmitter<any>();
	@Output() educationAddFnGs: EventEmitter<any> = new EventEmitter<any>();

	public fileServerUrl: string = environment.urls.fileServerUrl_Obj;

	private videoData: any;
	private schoolSelected: boolean = false;
	private degreeSelected: boolean = false;
	private FOSSelected: boolean = false;
	private citySelected: boolean = false;
	private _location: string = '';
	private oldData: any;
	private oldDataGT: any;
	private inGetStartedController: any;

	public suggest: boolean = false;
	public muteClassAdd: boolean = true;
	public dSelected: boolean = false;
	public schoolEdited: boolean = false;
	public degreeEdited: boolean = false;
	public FOSEdited: boolean = false;
	public gpaEdited: boolean = false;
	public videoEditted: boolean = false;
	public isVideoMuted: boolean = false;
	public videoDeleted: boolean = false;
	public showAddtolist: boolean = false;
	public showDegreeAddtolist: boolean = false;
	public showFosAddtolist: boolean = false;
	public showSchoolAddtolist: boolean = false;

	public location: string = '';
	public notes: any;
	public gpa: number = 0;
	public GPAErrorMessage: string = '';
	public showGPAError: boolean = false;
	public startYear: string = 'Year:';
	public currentYear: any = new Date().getFullYear();
	public maximumYear: any = this.currentYear + 12;
	public endYear = 'Year:';
	public endYears: number[] = [];

	/** Option lists for <scroll-select>, which caps its menu at ten rows. The
	 *  native <select> popup is drawn by the OS and cannot be capped from CSS. */
	public yearOptions: ScrollSelectOption[] = [];
	public endYearOptions: ScrollSelectOption[] = [];
	public school: string = '';
	public schoolId: any;
	public schoolUrl: string = '';
	public showSchoolError: boolean = false;
	public schoolErrorMessage: string = '';
	public degree: string = '';
	public degreeId: any;
	public showDegreeError: boolean = false;
	public degreeErrorMessage: string = '';
	public fos: string = '';
	public fosId: any;
	public showFOSError: boolean = false;
	public FOSErrorMessage: string = '';
	public city: string = '';
	public cityErrorMessage: string = '';
	public showCityError: boolean = false;
	public endMonth: any = { id: '0' };
	public startMonth: any = { id: '0' };
	public selectedVideoUrl: any;
	public videoSelected: any;
	public rawVideoUrl: any;
	public maxLength: number = 2000;
	public suggestions: any[] = [];
	public hasToShowSchoolSuggestions: boolean = false;
	public suggestionsDegree: any[] = [];
	public hasToShowDegreeSuggestions: boolean = false;
	public suggestionsFos: any[] = [];
	public hasToShowFOSSuggestions: boolean = false;
	public startDateError: boolean = false;
	public endDateError: boolean = false;
	public timePeriodError: boolean = false;
	public startDateErrorMessage: string = '';
	public endDateErrorMessage: string = '';
	public timePeriodErrorMessage: string = '';
	public photoSelected: boolean = false;
	public selectedPhoto: any;

	public parentobj: any = {
		city: '',
		showCityError: ''
	};

	public valueUpdated: boolean = false;

	constructor(public modal: NgbActiveModal,
		private sanitizer: DomSanitizer,
		private autocompleteService: AutocompleteService,
		private eventService: EventService,
		private modalService: NgbModal,
		private utilityService: UtilityService,
		private mediaUploadService: MediaUploadService,
		private toastr: ToastrService) { }

	ngOnInit() {
		this.yearOptions = Array.from({ length: 64 },
			(_, i) => ({ value: `${this.currentYear - i}`, label: `${this.currentYear - i}` }));

		this.data.months = [
			{ id: '0', name: 'Month' },
			{ id: '1', name: 'January' },
			{ id: '2', name: 'February' },
			{ id: '3', name: 'March' },
			{ id: '4', name: 'April' },
			{ id: '5', name: 'May' },
			{ id: '6', name: 'June' },
			{ id: '7', name: 'July' },
			{ id: '8', name: 'August' },
			{ id: '9', name: 'September' },
			{ id: '10', name: 'October' },
			{ id: '11', name: 'November' },
			{ id: '12', name: 'December' }
		];
		// condition if edit on get started page
		if (this.id && this.data) {
			this.inGetStartedController = true;
			let data = this.data;
			this.oldDataGT = this.data;
			this.id = data.id;
			this.degree = data.degree;
			this.degreeId = data.degree;
			this.endMonth = { id: data.endMonth != null ? data.endMonth.toString() : '0' };
			this.city = data.Location;
			this.endYear = data.endYear.toString();
			this.fos = data.fos;
			this.fosId = data.fosId;
			this.gpa = data.gpa;
			this.notes = data.notes;
			this.school = data.school;
			this.schoolId = data.school;
			this.schoolUrl = normalizeLogoUrl(data.schoolUrl);
			this.startMonth = { id: data.startMonth != null ? data.startMonth.toString() : '0' };
			this.startYear = data.startYear.toString();
			this.videoData = data.videoData;
			this.videoSelected = !((data.videoUrl.toString() === '' || data.videoUrl.toString() === this.fileServerUrl));
			this.selectedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.videoUrl);
			this.rawVideoUrl = data.videoUrl;
			this.updateEndYears();
		}

		// condition if on profile page
		if (this.data && this.data.COGUID) {
			this.inGetStartedController = false;
			this.oldData = this.data;
			let data = this.data;
			this.id = data.Id;
			this.degree = data.Degree;
			this.degreeId = data.Degree;
			this.endMonth = { id: data.EndMonth != null ? data.EndMonth.toString() : '0' };

			if (data.Location) {
				if (data.Location.Locality) {
					this._location = data.Location.Locality;
				} else {
					this._location = data.Location;
				}
			}

			this.city = this._location;
			this.location = this._location;
			this.endYear = data.End.toString();
			this.fos = data.FieldOfStudy;
			this.fosId = 0;
			this.gpa = data.GPA;
			this.notes = (data.Notes === undefined) ? '' : data.Notes;
			this.school = data.College.Name;
			this.schoolId = data.College.Name;
			this.schoolUrl = normalizeLogoUrl(data.College.LogoUrl);
			this.startMonth = { id: data.StartMonth != null ? data.StartMonth.toString() : '0' };
			this.startYear = data.Start.toString();
			this.videoData = undefined;
			this.videoSelected = !((data.VideoUrl.toString() === '' || data.VideoUrl.toString() === this.fileServerUrl));
			this.selectedVideoUrl = data.VideoUrl ? this.sanitizer.bypassSecurityTrustResourceUrl(data.VideoUrl) : '' ;
			// was '' here, which dropped the existing video's path on edit
			this.rawVideoUrl = data.VideoUrl || '';
			this.updateEndYears();
		}

		this.updateEndYears();

		this.subs.add(this.eventService.subscribe('video-selected', (value) => {
			// video selected
			this.muteClassAdd = true;
			this.videoEditted = true;
			this.videoSelected = true;
			this.selectedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(value.data.url);
			this.videoData = value.data.videoData;
			this.rawVideoUrl = value.data.url;
			if (document.getElementById('muteBtn')) {
				this.muted(true);
			}
			this.valueUpdated = true;
		}));

	}

	ngAfterViewInit() {
		this.muted(true);
	}

	remaining() {
		return this.maxLength - document.getElementsByTagName('textarea')[0].value.length;
	}

	muted(val: boolean) {
		if (document.getElementById('vidPreview')) {
			if (val !== undefined && val !== null) {
				(document.getElementById('vidPreview') as HTMLMediaElement).muted = val;
				this.muteClassAdd = val;
			}
		}
	}

	// recordVideo() {

	// 	this.muteClassAdd = true;
	// 	this.muted(true);
	// 	let modal = this.modalService.open(ThirtySecondsVideoRecordModalComponent,
	// 		{ windowClass: 'modal-theme-unnanu-v2 video-recorder-popup', backdrop: 'static', keyboard: false });
	// }

		recordVideo() {


			this.muteClassAdd = true;
			this.muted(true);

			// Delay modal opening slightly
			setTimeout(() => {
				this.modalService.open(ThirtySecondsVideoRecordModalComponent,
					{ windowClass: 'modal-theme-unnanu-v2 video-recorder-popup', backdrop: 'static', keyboard: false });
			}, 50);


		}
	positionVideo() {
		let selectedVideo = (document.querySelector('#vidPreview') as HTMLElement);
		let leftMargin = ((selectedVideo.offsetWidth - selectedVideo.offsetHeight) / 2) * -1;
		(document.getElementById('vidPreview') as HTMLElement).style.marginLeft = `${leftMargin}px`;
		if (!this.videoEditted) {
			this.muted(true);
		}
	}


	suggestSchools() {
		this.validateSchool();
		if (this.school.trim().length >= 3) {
			this.showAddtolist = false;
			return this.autocompleteService.get(this.school, 'college').pipe(map((response: any) => {
				if (
					response.status === 200 &&
					response.Code === 200 &&
					response.Data.length > 0
				) {
					this.suggestions = response.Data;
					this.hasToShowSchoolSuggestions = true;
					return this.suggestions.slice(0, 10);
				} else {
					// Add New Position
					this.suggestions = [];
					this.hasToShowSchoolSuggestions = false;
					return this.suggestions.slice(0, 10);
				}
			})
			);
		} else {
			this.hasToShowSchoolSuggestions = false;
			return of([]);
		}
	}

	searchSchool: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			switchMap(() => this.suggestSchools().pipe(catchError(() => of([]))))
		)

	schoolSelectedFn(event: any) {
		event.preventDefault();
		let schoolName = event.item.Name;
		let id = event.item.Id;
		let url = normalizeLogoUrl(event.item.LogoUrl);
		// do what you want to do
		if (schoolName !== '') {
			this.school = schoolName;
			this.schoolId = id;
			this.schoolUrl = url;
			this.schoolSelected = true;
			this.showSchoolAddtolist = false;
		} else {
			this.school = '';
		}
		this.hasToShowSchoolSuggestions = false;
		this.showAddtolist = false;
		this.showSchoolAddtolist = false;
	}

	hideSchoolSuggestions() {
		// This was copied from the certification modal and still compared against
		// oldData.Authority - an education record has College, not Authority, so
		// reading .Name off undefined threw on every blur of the School field.
		// Every branch of that tree only re-trimmed a value already trimmed on the
		// line above, so the comparison is gone rather than repointed.
		this.school = this.school.trim();
		this.hasToShowSchoolSuggestions = false;
		if (!this.schoolSelected) {
			this.validateSchool();
		}
	}

	validateSchool() {
		if (!this.school.trim()) {
			this.schoolErrorMessage = 'Enter School Name';
			this.showSchoolError = true;
		} else {
			this.showSchoolError = false;
		}
	}

	suggestDegrees() {
		this.validateDegree();
		this.degreeSelected = false;
		if (this.degree) {
			if (this.degree.trim().length >= 3) {
				return this.autocompleteService.get(this.degree, 'degree').pipe(map((response: any) => {
					if (
						response.status === 200 &&
						response.Code === 200 &&
						response.Data.length > 0
					) {
						this.suggestionsDegree = response.Data;
						return this.suggestionsDegree.slice(0, 10);
					} else {
						// Add New Position
						this.suggestionsDegree = [];
						this.hasToShowDegreeSuggestions = false;
						return this.suggestionsDegree.slice(0, 10);
					}
				})
				);
			} else {
				this.hasToShowDegreeSuggestions = false
				return of([]);
			}
		} else {
			this.hasToShowDegreeSuggestions = false
			return of([]);
		}

	}

	searchDegree: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			switchMap(() => this.suggestDegrees().pipe(catchError(() => of([]))))
		)

	degreeFormatter = (result: any) => result.Name;

	degreeSelectedFn(event: any) {
		event.preventDefault();
		let degreeName = event.item.Name;
		let id = event.item.Id;
		// do what you want to do
		if (degreeName !== '') {
			this.dSelected = true;
			this.suggest = true;
			this.degree = degreeName;
			this.degreeId = id;
			this.degreeSelected = true;
			this.hasToShowDegreeSuggestions = false;
			this.showDegreeAddtolist = false;
		} else {
			this.degree = '';
		}
		this.showDegreeAddtolist = false;
	}

	hideDegreeSuggestions() {
		this.degree = this.degree.trim();
		this.hasToShowDegreeSuggestions = false;
		if (!this.degreeSelected) {
			if (!this.inGetStartedController && this.oldData) {
				if (this.oldData.JobTitle !== this.degree) {
					// this.degree = '';
				}
			} else {
				// this.degree = '';
				if (this.inGetStartedController && this.oldDataGT) {
					if (this.oldDataGT.positionName !== this.degree) {
						// this.degree = '';
					}
				} else {
					// this.degree = '';
				}
			}
			this.validateDegree();
		}
	}

	validateDegree() {
		if (!this.degree.trim()) {
			this.degreeErrorMessage = 'Please select your position';
			this.showDegreeError = true;
		} else {
			this.showDegreeError = false;
		}
	}

	suggestFOSs() {
		this.FOSEdited = true;
		this.FOSSelected = false;
		this.validateFOS();
		if (this.fos) {
			if (this.fos.trim().length >= 3) {
				return this.autocompleteService.get(this.fos, 'course').pipe(map((response: any) => {
					if (
						response.status === 200 &&
						response.Code === 200 &&
						response.Data.length > 0
					) {
						this.suggestionsFos = response.Data;
						this.hasToShowFOSSuggestions = false;
						return this.suggestionsFos.slice(0, 10);
					} else {
						// Add New Position
						this.suggestionsFos = [];
						this.hasToShowFOSSuggestions = false;
						return this.suggestionsFos.slice(0, 10);
					}
				})
				);
			} else {
				this.hasToShowFOSSuggestions = false
				return of([]);
			}
		} else {
			this.hasToShowFOSSuggestions = false
			return of([]);
		}

	}

	searchFos: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
		text$.pipe(
			debounceTime(200),
			distinctUntilChanged(),
			switchMap(() => this.suggestFOSs().pipe(catchError(() => of([]))))
		)

	fosFormatter = (result: any) => result.Name;

	fosSelectedFn(event: any) {
		event.preventDefault();
		let fos = event.item.Name;
		let id = event.item.Id;
		if (fos !== '') {
			this.fos = fos;
			this.fosId = id;
			this.FOSSelected = true;
			this.showFosAddtolist = false;
		} else {
			this.fos = '';
		}
		this.hasToShowFOSSuggestions = false;
		this.showFosAddtolist = false;
	}

	hideFOSSuggestions() {
		this.fos = this.fos.trim();
		this.hasToShowFOSSuggestions = false;
		if (!this.FOSSelected) {
			if (!this.inGetStartedController && this.oldData) {
				if (this.oldData.JobTitle !== this.fos) {
					// this.fos = '';
				}
			} else {
				// this.fos = '';
				if (this.inGetStartedController && this.oldDataGT) {
					if (this.oldDataGT.positionName !== this.fos) {
						// this.fos = '';
					}
				} else {
					// this.fos = '';
				}
			}
			this.validateFOS();
		}
	}

	validateFOS() {
		if (!this.fos.trim()) {
			this.FOSErrorMessage = 'Please select your position';
			this.showFOSError = true;
		} else {
			this.showFOSError = false;
		}
	}

	validateCity() {
		if (this.city === '' && this.parentobj.city === '') {
			this.cityErrorMessage = 'Enter location';
			this.showCityError = true;
		} else {
			this.showCityError = false;
		}
	}

	formatGPA(value?: any) {
		this.validateGpa();
	}

	deleteData() {
		if (this.delete) {
			this.deleteFn.emit(this.data.COGUID);
			this.close();
		}
	}

	saveData() {
		this.school = this.school.trim();
		this.degree = this.degree.trim();
		this.fos = this.fos.trim();
		this.validateSchool();
		this.validateTimePeriod();
		this.validateDegree();
		this.validateFOS();
		this.validateGpa();
		this.validateCity();

		if ((this.showSchoolError || this.showDegreeError || this.parentobj.showCityError || this.showFOSError || this.showGPAError || this.startDateError || this.endDateError || this.timePeriodError)) {

		} else {
			let guid;
			if (this.data.id) {
				guid = this.id;
			} else if (this.data && this.data.COGUID) {
				guid = this.data.COGUID;
			} else {
				guid = this.utilityService.genGuid();
			}
			let educationObject = {
				key: guid,
				value: {
					id: this.id,
					videoData: this.videoData,
					// rawVideoUrl, not selectedVideoUrl. selectedVideoUrl is a
					// SafeResourceUrl, and calling toString() on one returns Angular's
					// wrapper text - "SafeValue must use [property]=binding: <url>" -
					// not the URL. rawVideoUrl holds the path the server gave us and
					// was already being assigned for exactly this purpose, but nothing
					// ever read it.
					videoUrl: this.rawVideoUrl || '',
					school: this.school,
					schoolId: this.school,
					schoolUrl: this.schoolUrl,
					Location: (this.parentobj.city !== '' ? this.parentobj.city : this.city),
					degree: this.degree,
					degreeId: this.degree,
					fos: this.fos,
					fosId: this.fosId,
					gpa: this.gpa,
					startMonth: Number(this.startMonth.id),
					startYear: this.startYear,
					endMonth: Number(this.endMonth.id),
					endYear: this.endYear,
					notes: this.notes,
					isSaved: false, // status to keep upload status
					city: this.city
				}
			}
			if (this.id || (this.data && this.data.COGUID)) {
				if (this.pageStatus === 1) {
					this.educationEditFn.emit({ data: educationObject, videoEditted: this.videoEditted, ctrl: this.ctrl, videoDeleted: this.videoDeleted })
					this.eventService.broadcast('education-saved',{
						response: educationObject
					})
				} else {
					this.educationEditFnGs.emit({ data: educationObject, videoEditted: this.videoEditted, ctrl: this.ctrl, videoDeleted: this.videoDeleted })
				}
			} else {
				if (this.pageStatus === 1) {
					this.educationAddFn.emit({ data: educationObject, ctrl: this.ctrl, videoEditted: this.videoEditted })
				} else {
					this.educationAddFnGs.emit({ data: educationObject, ctrl: this.ctrl, videoEditted: this.videoEditted })
				}
			}
			this.close();
		}
	}

	validateGpa() {
		if (this.gpa === null || this.gpa < 0) {
			this.GPAErrorMessage = 'Enter between 0 and 10';
			this.showGPAError = true;
		} else if (this.gpa > 9.99) {
			this.GPAErrorMessage = 'GPA should be between 0 & 10';
			this.showGPAError = true;
			this.showGPAError = true;
		} else {
			this.showGPAError = false;
		}
	}

	currentlyWorking() {
		this.endYear = 'Year:';
		this.endMonth = { id: '0' };
		this.updateEndYears();
	}

	public updateEndYears() {
		const fromYear = this.startYear !== 'Year:' ? Number(this.startYear) : null;
		const minYear = fromYear !== null ? fromYear : this.currentYear - 63;
		this.endYears = [];
		for (let y = this.maximumYear; y >= minYear; y--) {
			this.endYears.push(y);
		}
		this.endYearOptions = this.endYears.map(y => ({ value: `${y}`, label: `${y}` }));
		if (fromYear !== null && this.endYear !== 'Year:' && Number(this.endYear) < fromYear) {
			this.endYear = 'Year:';
			this.endMonth = { id: '0' };
		}
	}

	// time period field validation
	public validateTimePeriod() {
		this.updateEndYears();
		if (this.startMonth.id === '0' || this.startYear === 'Year:') {
			this.startDateErrorMessage = 'Select month & year';
			this.startDateError = true;
		} else {
			this.startDateError = false;
		}

		if (this.endMonth.id === '0' || this.endYear === 'Year:') {
			this.endDateErrorMessage = 'Select month & year';
			this.endDateError = true;
		} else {
			this.endDateError = false;
		}

		const startY = Number(this.startYear);
		const endY = Number(this.endYear);
		const startM = Number(this.startMonth.id);
		const endM = Number(this.endMonth.id);

		if (endY < startY) {
			this.timePeriodErrorMessage = 'End date cannot be before start date';
			this.timePeriodError = true;
		} else if (endY === startY && endM < startM) {
			this.timePeriodErrorMessage = 'End date cannot be before start date';
			this.timePeriodError = true;
		} else if (endY === startY && endM === startM) {
			this.timePeriodErrorMessage = 'End date cannot be the same as start date';
			this.timePeriodError = true;
		} else {
			this.timePeriodError = false;
		}
	}

	removeVideo() {
		const confirmModal = this.modalService.open(ConfirmAlertComponent, { backdrop: 'static', keyboard: false });
		confirmModal.componentInstance.msg = 'Are you sure you want to delete this video?';
		confirmModal.result.then(() => {
			if (this.id) {
				this.mediaUploadService.removePhoto('EDU_VIDEO', this.id).subscribe({
					next: () => {},
					error: (err: any) => {
						this.toastr.error(err?.error?.Message || err?.message || 'An unexpected error occurred. Please try again.');
					}
				});
			}
			this.valueUpdated = true;
			this.videoEditted = false;
			this.videoDeleted = true;
			this.videoSelected = false;
			this.selectedVideoUrl = undefined;
			this.videoData = undefined;
			if (document.getElementById('vidPreview')) {
				(document.getElementById('vidPreview') as HTMLMediaElement).muted = true;
			}
		}, () => {});
	}

	get monthOptions(): ScrollSelectOption[] {
		return (this.data?.months || []).map((m: any) => ({ value: m.id, label: m.name }));
	}

	getArray(n: number) {
		return new Array(n);
	}

	adjustCalenderStart(selectedDate: any) {
		let date = new Date()
		if (date.getFullYear() === Number(selectedDate)) {
			this.data.months_start = this.data.months_start.splice(0, date.getMonth() + 2);
		} else {
			if (this.data.months_start.length !== 13) {
				this.data.months_start = [...this.data.months_new];
			}
		}
	}

	adjustCalenderEnd(selectedDate: any) {
		let date = new Date()
		if (date.getFullYear() === Number(selectedDate)) {
			this.data.months_end = this.data.months_end.splice(0, date.getMonth() + 2);
		} else {
			if (this.data.months_end.length !== 13) {
				this.data.months_end = [...this.data.months_new];
			}
		}
	}

	onChange(event: any){
		this.valueUpdated = true;
	}

	close() {
		this.modal.dismiss();
	}


	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}
}
